import axios from 'axios';
import moment from 'moment';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/ppnmasukan${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                let resp;
                // if (data.apinvkey) {
                //     resp = await axios.put(`/ppnmasukan/${data.apinvkey}`, data);
                // } else {
                    resp = await axios.post('/ppnmasukan', data);
                // }
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    // printjv(obj = {}) {
    // return new Promise(async (resolve, reject) => {
    //     let url;
    //     let str = '';
    //     try {
    //         if (obj.apinvkey) {
    //             str = '?key=' + encodeURIComponent(obj.apinvkey);
    //             url = `/apinv/printjv`;
    //         } else {
    //             str = `?nomor=${encodeURIComponent(obj.nomor)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`;
    //             url = `/buku/printjv`;
    //         }

    //         url += str;
    //         const { data } = await axios.get(url);
    //         const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
    //         resolve(link);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },    
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url ;
            let str = '';
            try {
                switch (obj.fsubkode2) {
                    // case 'arinvtt':
                    //     str = '?key=' + encodeURIComponent(obj.apinvkey);
                    //     url = `/arinv/printjv`;
                    //     break;

                    case 'advsettlheader':
                            str = '?key=' + encodeURIComponent(obj.apinvkey);
                            url = `/advsettle/printjv`;
                            break;

                    case 'expenreimburs':
                        str = '?key=' + encodeURIComponent(obj.apinvkey);
                        url = `/expense/printjv`;
                        break;

                    case 'ap_invoice_tt':
                        str = '?key=' + encodeURIComponent(obj.apinvkey);
                        url = `/apinv/printjv`;
                        break;

                    // case 'inventory_issued':
                    //     str = '?key=' + encodeURIComponent(obj.apinvkey);
                    //     url = `/inventoryout/printjv`;
                    //     break;
            
                    case 'tranbank':
                        str ='?key=' + encodeURIComponent(obj.apinvkey);
                        if (obj.nomor.substr(1, 1) == 'M'){
                            url = `/tranbank/printreceivejv`;

                        } else {
                            url = `/tranbank/printpaymentjv`;
                        }
                        break;

                    default:
                        str = `?nomor=${encodeURIComponent(obj.nomor)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`;
                        url = `/buku/printjv`;
                        break;
                }

                url += str;
                const { data } = await axios.get(url);

                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportcsv(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/ppnmasukan/exportcsv${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'e-faktur-import-FM.csv');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/ppnmasukan/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'ppn_masukan.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    taxgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/vendor/taxgroup`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }

};